import ValidationService from './ValidationService';

import apiService from '../ApiService';

export default new ValidationService(apiService);
